const isNullOrEmpty = (str: any): boolean => {
    if (
        typeof str === "undefined" ||
        str == null ||
        str.toString().length === 0 ||
        str.toString().trim().length === 0
    ) {
        return true;
    } else {
        return false;
    }
};

const getUserLang = (): string => {
    var userLang: string = navigator.language || (navigator as any).userLanguage;
    var lang = "en";
    if (!isNullOrEmpty(userLang) && userLang.indexOf("de") > -1) {
        lang = "de";
    } else if (!isNullOrEmpty(userLang) && userLang.indexOf("pl") > -1) {
        lang = "pl";
    }
    return lang;
}

export {
    isNullOrEmpty, getUserLang
};
